import { Button as BaseButton } from '@lounge-fe/ui-kit'
import { ButtonProps } from './types'
import { twMerge } from 'tailwind-merge'

export const Button = ({
  className,
  color,
  label,
  link,
  size,
  variant,
}: ButtonProps) => {
  return (
    <div className="flex justify-center">
      <BaseButton
        as="a"
        href={link}
        size={size}
        color={color}
        variant={variant}
        className={twMerge('mx-auto', className)}
      >
        {label}
      </BaseButton>
    </div>
  )
}
